module.exports = __webpack_public_path__ + "f8adc5f50304e0e8b0fdf46701d6d532.pdf";